/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Cta_TitleInputs */

const en_projects_cta_title = /** @type {(inputs: Projects_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are you working on?`)
};

const lv_projects_cta_title = /** @type {(inputs: Projects_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pie kā Jūs strādājat?`)
};

/**
* | output |
* | --- |
* | "What are you working on?" |
*
* @param {Projects_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const projects_cta_title = /** @type {((inputs?: Projects_Cta_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Cta_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_projects_cta_title(inputs)
	return en_projects_cta_title(inputs)
});